<template>
  <div class="wrapper">
    <div class="container">
      <div class="login-card" v-if="!isChangePassword">
        <div class="logo">
          <img :src="require('@/assets/images/login/user.png')" alt="" />
        </div>
        <h2>会员登录</h2>

        <form id="loginForm" @submit.prevent>
          <div class="input-group">
            <label for="username">用户名</label>
            <input
              v-model="username"
              type="text"
              id="username"
              class="input-field"
              placeholder="请输入用户名"
              required=""
            />
            <div class="error-message" id="usernameError"></div>
          </div>

          <div class="input-group">
            <label for="password">密码</label>
            <input
              v-model="password"
              type="password"
              id="password"
              class="input-field"
              placeholder="请输入密码"
              required=""
            />
            <div class="error-message" id="passwordError"></div>
          </div>

          <div class="input-group">
            <label for="captcha">验证码</label>
            <div class="captcha-container">
              <img
                @click.stop="getVerifycode()"
                id="validate"
                alt="点击更换"
                :src="img"
                style="cursor: pointer; border-radius: 10px; height: 50px"
                class="valid-pic"
                onclick="this.src=&#39;/defaultKaptcha?d=&#39;+new Date()*1"
              />
              <input
                v-model="verifycode"
                type="text"
                id="captcha"
                class="input-field captcha-input"
                placeholder="请输入验证码"
                required=""
                maxlength="4"
              />
              <button
                type="button"
                class="refresh-btn"
                id="refreshCaptcha"
                @click.stop="getVerifycode()"
              >
                <i class="fas fa-sync-alt"></i>
              </button>
            </div>
            <div class="error-message" id="captchaError"></div>
          </div>

          <button type="submit" class="login-btn" @click.prevent="login">
            登录
          </button>
        </form>

        <!-- <div class="options">
          <label class="remember">
            <input type="checkbox" id="remember" /> 记住我
          </label>
          <a href="https://v.bootstrapmb.com/2025/8/ypxim16284/#" class="forgot"
            >忘记密码?</a
          >
        </div>

        <div class="footer">
          <p>© 2023 安全验证系统 | 保护您的隐私安全</p>
        </div> -->
      </div>

      <div class="login-card" v-else>
        <div class="logo">
          <i class="fas fa-lock"></i>
        </div>
        <h2>首次密码设置</h2>

        <form id="loginForm" @submit.prevent>
          <div class="input-group">
            <label for="username">当前密码</label>
            <input
              v-model="oldPassword"
              type="text"
              id="username"
              class="input-field"
              placeholder="请输入当前密码"
              required=""
            />
            <div class="error-message" id="usernameError"></div>
          </div>

          <div class="input-group">
            <label for="password">新密码</label>
            <input
              v-model="newPassword"
              type="password"
              id="password"
              class="input-field"
              placeholder="请输入新密码"
              required=""
            />
            <div class="error-message" id="passwordError"></div>
          </div>

          <div class="input-group">
            <label for="password">确认密码</label>
            <input
              v-model="repeatNewPassword"
              type="password"
              id="password"
              class="input-field"
              placeholder="请确认密码"
              required=""
            />
            <div class="error-message" id="passwordError"></div>
          </div>

          <button type="submit" class="login-btn" @click="changePassword">
            下一步
          </button>
        </form>

        <!-- <div class="options">
          <label class="remember">
            <input type="checkbox" id="remember" /> 记住我
          </label>
          <a href="https://v.bootstrapmb.com/2025/8/ypxim16284/#" class="forgot"
            >忘记密码?</a
          >
        </div>

        <div class="footer">
          <p>© 2023 安全验证系统 | 保护您的隐私安全</p>
        </div> -->
      </div>
    </div>
  </div>
</template>

<script>
import userImg from "@/assets/images/login/user.png";
export default {
  data() {
    return {
      isChangePassword: false,
      username: "",
      password: "",
      signid: "",
      verifycode: "",
      img: "",
      changePasswordName: "",
      oldPassword: "",
      newPassword: "",
      repeatNewPassword: "",
    };
  },
  metaInfo() {
    return {
      meta: [
        {
          name: "viewport",
          content:
            "width=device-width,initial-scale=1,maximum-scale=1,minimum-scale=1,userscalable=no",
        },
      ],
    };
  },
  mounted() {
    this.initData();
  },
  methods: {
    initData() {
      this.getVerifycode();
    },
    reset() {
      this.isChangePassword = false;
      // this.oldPassword = "";
      // this.newPassword = "";
      // this.repeatNewPassword = "";
    },
    async changePassword() {
      if (this.oldPassword && this.newPassword == this.repeatNewPassword) {
        let data = {
          username: this.changePasswordName,
          password: this.oldPassword,
          newpwd: this.newPassword,
        };
        let result = await this.$http.postAxiosMethod("/user/newpwd", data);
        if (result.code == 0) {
          document.activeElement.blur();
          this.$alert("修改成功，请重新登录。", "提示")
            .then((res) => {
              location.reload();
            })
            .catch((e) => {});
        } else {
          this.$alert(result.msg);
        }
      } else {
        document.activeElement.blur();
        this.$alert("请输入密码或者新密码两次输入不一致。", "提示");
      }
    },
    async getVerifycode() {
      let result = await this.$http.postAxiosMethod("/user/verifycode");
      if (result.code == 0) {
        this.img = result.data.img;
        this.signid = result.data.Signid;
      }
    },
    async login() {
      let data = {
        username: this.username,
        password: this.password,
        verifycode: this.verifycode,
        signid: this.signid,
      };
      let result = await this.$http.postAxiosMethod("/user/login", data);
      if (result.code == 0) {
        sessionStorage.setItem("userInfo", JSON.stringify(result.data));
        this.$router.push("/userAgreement");
      } else if (result.code == -104) {
        document.activeElement.blur();
        this.$alert(result.msg, "提示")
          .then((res) => {
            this.changePasswordName = this.username;
            this.isChangePassword = true;
          })
          .catch((e) => {});
      } else {
        this.getVerifycode();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url(../../assets/login/all.min.css);
.wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #edefef, #ebedeb);
}
.container {
  width: 100%;
  max-width: 420px;
}

.login-card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.15);
  padding: 35px 30px;
  text-align: center;
  transition: transform 0.3s ease;
}

.login-card:hover {
  transform: translateY(-5px);
}

.logo {
  width: 80px;
  height: 80px;
  margin: 0 auto 15px;
  background: linear-gradient(135deg, #6e8efb, #a777e3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.logo i {
  font-size: 40px;
  color: white;
}

h2 {
  color: #333;
  margin-bottom: 25px;
  font-weight: 600;
}

.input-group {
  margin-bottom: 20px;
  text-align: left;
}

label {
  display: block;
  margin-bottom: 8px;
  color: #555;
  font-weight: 500;
}

.input-field {
  width: 100%;
  padding: 14px 15px;
  border: 2px solid #ddd;
  border-radius: 10px;
  font-size: 16px;
  transition: border-color 0.3s;
}

.input-field:focus {
  border-color: #6e8efb;
  outline: none;
}

.captcha-container {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}

.captcha-code {
  flex: 1;
  background: #f0f4ff;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  font-weight: bold;
  letter-spacing: 3px;
  color: #333;
  user-select: none;
  height: 55px;
  cursor: pointer;
  transition: background 0.3s;
}

.captcha-code:hover {
  background: #e1e9ff;
}

.captcha-input {
  flex: 1;
}

.refresh-btn {
  background: #f0f4ff;
  border: none;
  border-radius: 10px;
  width: 55px;
  cursor: pointer;
  transition: background 0.3s;
}

.refresh-btn:hover {
  background: #e1e9ff;
}

.refresh-btn i {
  font-size: 22px;
  color: #6e8efb;
}

.login-btn {
  width: 100%;
  padding: 14px;
  background: linear-gradient(135deg, #6e8efb, #a777e3);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.3s;
}

.login-btn:hover {
  opacity: 0.9;
}

.options {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  font-size: 14px;
}

.remember {
  display: flex;
  align-items: center;
  color: #666;
}

.remember input {
  margin-right: 6px;
}

.forgot {
  color: #6e8efb;
  text-decoration: none;
}

.forgot:hover {
  text-decoration: underline;
}

.footer {
  margin-top: 25px;
  color: #777;
  font-size: 13px;
}

.error-message {
  color: #ff4757;
  font-size: 14px;
  margin-top: 5px;
  text-align: left;
  display: none;
}

@media (max-width: 480px) {
  .login-card {
    padding: 25px 20px;
  }

  .captcha-container {
    flex-direction: column;
  }

  .refresh-btn {
    width: 100%;
    height: 45px;
  }
}
</style>
